import { useState } from "react";

import { classNames } from "../../../../shared/lib/classNames";

import { useScrollBlock } from "../../../../shared/hooks/useScrollBlock";
import { NavigationList } from "../NavigationList";

import styles from "./Burger.module.scss";
import { Link } from "react-router-dom";
import { LogoFooter } from "../../../../shared/assets/svg";
import { RoutesEnum } from "../../../../shared/constants/routes";
import { SubscribeVacancy } from "../SubscribeVacancy";

export const Burger = () => {
    const [isOpen, setIsOpen] = useState(false);

    useScrollBlock(isOpen);

    const handleToggle = () => setIsOpen((prev) => !prev);

    return (
        <div className={styles.wrapper}>
            <button
                onClick={handleToggle}
                className={classNames({
                    cls: styles.burger,
                    mods: { [styles.active]: isOpen },
                })}
            ></button>
            {isOpen && (
                <div className={styles.menu}>
                    <Link to={RoutesEnum.Home}>
                        <LogoFooter className={styles.logo} />
                    </Link>
                    <NavigationList onClick={handleToggle} />
                    <SubscribeVacancy />
                </div>
            )}
        </div>
    );
};
